import React from "react";
import { Alert, Row, Col } from "reactstrap";
import { Icon } from "@cadmakers-ui/icons";
import iconStyles from "../Styles/Icons.module.scss";
import styles from "../Styles/CommentsDisabledDisplay.module.scss";

export default class CommentsDisabledDisplay extends React.Component {
  render() {
    return (
      <Alert color="secondary">
        <Row>
          <Col colSpan={8}>
            <p>
              <b>Comments Disabled</b>
            </p>
            <p>Comments have been disabled for this Item</p>
          </Col>
          <Col colSpan={4} className={iconStyles.errorIconCol}>
            <Icon
              appName="GeneralLayout"
              assetName="GENERAL_L_Comments"
              className={iconStyles.smallIcon}
            />
          </Col>
        </Row>
      </Alert>
    );
  }
}
